export default class ApplicationsNonEmploymentIncome {
	constructor(init) {
		this.frequency = null;
		this.amount = null;
		this.description = null;

		if (init) {
			this.frequency = init.frequency;
			this.amount = init.amount;
			this.description = init.description;
		}
	}
}
